import { render, staticRenderFns } from "./DocumentConfiguration.vue?vue&type=template&id=00e5b8b4&"
import script from "./DocumentConfiguration.vue?vue&type=script&lang=js&"
export * from "./DocumentConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports